import { render, staticRenderFns } from "./OrderDetailBox.vue?vue&type=template&id=a1b0ca74&"
import script from "./OrderDetailBox.vue?vue&type=script&lang=ts&"
export * from "./OrderDetailBox.vue?vue&type=script&lang=ts&"
import style0 from "./OrderDetailBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1b0ca74')) {
      api.createRecord('a1b0ca74', component.options)
    } else {
      api.reload('a1b0ca74', component.options)
    }
    module.hot.accept("./OrderDetailBox.vue?vue&type=template&id=a1b0ca74&", function () {
      api.rerender('a1b0ca74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OrderDetailBox.vue"
export default component.exports